// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".progress_page .page_details .timeline .item .desc[data-v-49bc0f72]{font-size:.10417rem}", ""]);
// Exports
module.exports = exports;
